<template>
  <b-sidebar
    id="cost-positions-modal"
    v-model="isVisible"
    width="540px"
    class="px-3 py-2"
    bg-variant="white"
    right
    backdrop
    shadow
    no-header
  >
    <div class="sidebar-container">
      <dx-scroll-view>
        <header class="d-flex justify-content-end">
          <dx-button
            :text="$t('Close')"
            class="close-text-button"
            icon="ace-icon icon-close"
            @click="isVisible = false"
          />
        </header>
        <b-row class="mb-2">
          <b-col>
            <h2 class="cost-modal__header">
              {{ $t('Rate') }}
            </h2>
          </b-col>
        </b-row>
        <!-- Nav tabs -->
        <nav class="cost-modal__nav mb-3">
          <div
            class="nav nav-tabs"
            role="tablist"
          >
            <button
              class="nav-item nav-link"
              :class="isIncludedTab ? 'active' : ''"
              data-toggle="tab"
              role="tab"
              aria-controls="home"
              aria-selected="false"
              @click="isIncludedTab = true"
            >
              {{ $t('Included') }}
            </button>
            <button
              class="nav-item nav-link"
              :class="!isIncludedTab ? 'active' : ''"
              data-toggle="tab"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
              @click="isIncludedTab = false"
            >
              {{ $t('Not included') }}
            </button>
          </div>
        </nav>
        <!-- Tab panes -->
        <div
          id="myTabContent"
          class="tab-content"
        >
          <div
            class="tab-pane fade"
            :class="isIncludedTab ? 'show active' : ''"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div
              v-if="!costPositionsIncludes.length"
              class="cost-modal__no-data mb-2"
            >
              {{ $t('No positions selected') }}
            </div>
            <ul
              v-else
              class="cost-modal__list"
            >
              <li
                v-for="(item) in costPositionsIncludes"
                :key="item.description"
              >
                <span>
                  {{ item.description }}
                </span>
                <button
                  @click="deletePositionInclude(item)"
                />
              </li>
            </ul>
          </div>
          <div
            class="tab-pane fade"
            role="tabpanel"
            aria-labelledby="profile-tab"
            :class="!isIncludedTab ? 'show active' : ''"
          >
            <div
              v-if="!costPositionsNotIncludes.length"
              class="cost-modal__no-data mb-2"
            >
              {{ $t('No positions selected') }}
            </div>
            <ul
              v-else
              class="cost-modal__list"
            >
              <li
                v-for="item in costPositionsNotIncludes"
                :key="item.description"
              >
                <span>
                  {{ item.description }}
                </span>
                <button
                  @click="deletePositionNotInclude(item)"
                />
              </li>
            </ul>
          </div>
        </div>

        <b-row class="d-flex align-items-center">
          <b-col lg="8">
            <dx-form-group
              :label="$t('Add service')"
            >
              <dx-text-area
                v-model="newServiceDescription"
                :max-length="200"
                styling-mode="outlined"
              >
              </dx-text-area>
            </dx-form-group>
          </b-col>
          <b-col lg="4">
            <dx-button
              :text="$t('Add')"
              type="success"
              styling-mode="contained"
              class="custom-btn ml-auto"
              @click="addNewService"
            ></dx-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="dx-field-label">
              {{ $t('Default services') }}
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col>
            <dx-select-box
              v-model="oldPosition"
              :data-source="comboBoxPositions"
              :show-clear-button="false"
              styling-mode="outlined"
              :placeholder="$t('Select positions')"
              :no-data-text="$t('No positions to show')"
              display-expr="description"
              @valueChanged="returnPosition"
            />
          </b-col>
        </b-row>
        <div class="dx-field-value">
        </div>

        <b-row
          class="mx-0 mt-auto"
        >
          <dx-button
            :text="$t('Cancel')"
            type="success"
            styling-mode="text"
            class="custom-btn mr-2"
            width="180"
            @click="isVisible = false"
          />

          <dx-button
            :text="$t('Save')"
            type="success"
            styling-mode="contained"
            class="custom-btn ml-auto"
            width="260"
            @click="sendChosenPositions"
          />
        </b-row>
      </dx-scroll-view>
    </div>
  </b-sidebar>
</template>


<script>

import { DxButton, DxTextArea } from 'devextreme-vue';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxSelectBox from 'devextreme-vue/select-box';
import DxFormGroup from '@/components/common/DxFormGroup';


export default {
  name: 'CostPositionsModal',
  components: {
    DxButton,
    DxScrollView,
    DxTextArea,
    DxFormGroup,
    DxSelectBox,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    costDetailsIncludes: Array,
    costDetailsNotIncludes: Array,
    id: Number,
    tabInclude: Boolean,
    defaultCostDetails: Array,
  },
  data: () => ({
    allowDeletion: true,
    itemDeleteMode: 'static',
    costPositionsIncludes: [],
    costPositionsNotIncludes: [],
    newServiceDescription: '',
    animationEnabled: true,
    swipeEnabled: false,
    isIncludedTab: true,
    allNewCostPositions: [],
    oldPosition: undefined,
    comboBoxIncludePositions: [],
    comboBoxNotIncludePositions: [],
    defaultIncluded: [],
    defaultNotIncluded: [],

  }),
  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    comboBoxPositions() {
      return this.isIncludedTab ? this.comboBoxIncludePositions : this.comboBoxNotIncludePositions;
    },
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.costPositionsIncludes = JSON.parse(JSON.stringify(this.costDetailsIncludes));
        this.costPositionsNotIncludes = JSON.parse(JSON.stringify(this.costDetailsNotIncludes));
        this.setComboboxArrays();
      }
      if (!val) {
        this.$emit('refresh-tab', this.isIncludedTab);
      }
    },
    tabInclude(val) {
      this.isIncludedTab = val;
    },
  },
  mounted() {
  },

  methods: {
    returnPosition() {
      if (this.isIncludedTab) {
        this.costPositionsIncludes.push(this.oldPosition);
        this.comboBoxIncludePositions = this.comboBoxIncludePositions.filter(it => it.description !== this.oldPosition.description);
      } else {
        this.costPositionsNotIncludes.push(this.oldPosition);
        this.comboBoxNotIncludePositions = this.comboBoxNotIncludePositions.filter(it => it.description !== this.oldPosition.description);
      }

      this.oldPosition = undefined;
    },
    addNewService() {
      if (this.isIncludedTab) {
        this.costPositionsIncludes.push(
          {
            included: true,
            description: this.newServiceDescription,
            body: null,
            note: null,
          },
        );
      } else {
        this.costPositionsNotIncludes.push(
          {
            included: false,
            description: this.newServiceDescription,
            body: null,
            note: null,
          },
        );
      }

      this.newServiceDescription = '';
    },

    async sendChosenPositions() {
      this.allNewCostPositions = this.costPositionsIncludes.concat(this.costPositionsNotIncludes);
      await this.$http.post(`/tracking/api/freight_orders/${this.id}/cost-details/replace/`, this.allNewCostPositions)
        .then(() => {
          this.$emit('refresh-cost-positions');
        });


      this.isVisible = false;
    },

    deletePositionInclude(item) {
      const arrDescrDefPosInc = this.defaultCostDetails.filter(it => it.included).map(it => it.description);

      this.costPositionsIncludes = this.costPositionsIncludes.filter(it => it.description !== item.description);
      if (arrDescrDefPosInc.includes(item.description)) {
        this.comboBoxIncludePositions.push(item);
      }
    },

    deletePositionNotInclude(item) {
      const arrDescrDefPosNotInc = this.defaultCostDetails.filter(it => !it.included).map(it => it.description);

      this.costPositionsNotIncludes = this.costPositionsNotIncludes.filter(it => it.description !== item.description);
      if (arrDescrDefPosNotInc.includes(item.description)) {
        this.comboBoxNotIncludePositions.push(item);
      }
    },
    setComboboxArrays() {
      const arrDescrPosInc = this.costPositionsIncludes.map(it => it.description);
      const arrDescrPosNotInc = this.costPositionsNotIncludes.map(it => it.description);

      this.comboBoxIncludePositions = this.defaultCostDetails.filter(it => it.included).reduce((acc, it) => {
        if (!arrDescrPosInc.includes(it.description)) {
          acc.push(it);
        }
        return acc;
      }, []);

      this.comboBoxNotIncludePositions = this.defaultCostDetails.filter(it => !it.included).reduce((acc, it) => {
        if (!arrDescrPosNotInc.includes(it.description)) {
          acc.push(it);
        }
        return acc;
      }, []);
    },
  },
};
</script>

<style lang="scss" scoped>
  .sidebar-container {
    margin: 32px;
    header {
      margin-bottom: 25vh;
    }
  }
  .cost-modal__header {
    font-size: 24px;
  }

  .close-text-button {
    width: fit-content;
    color: #3C5AC3;
    background-color: white;
    box-shadow: none;
    &:hover {
      color: #2347C6;
      background-color: white;
      box-shadow: none;
    }
    &:active,
    &:focus {
      color: #3C5AC3;
      border: 2px solid #3C5AC3;
      background-color: white;
      box-shadow: none;
      transition: all 0.2s;
    }
  }

  .nav-tabs .nav-link {
    font-size: 18px;
    background-color: #fff;
    border: none;
    border-bottom: 1px solid #E0E6EE;
  }

  .nav-tabs .nav-link:hover {
    border-bottom-color: #2347C6;
  }
  .nav-tabs .nav-link:focus,
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #3C5AC3;
    border-bottom-color: #3C5AC3;
  }

  .cost-modal__list {
    font-size: 14px;
    margin-top: 32px;
    padding-left: 0;
    list-style: none;
    & li {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      padding: 1rem;
      background-color: #E6F3FA;
      border-radius: 8px;
      line-height: 17px;
      cursor: pointer;
    }
    & li:hover {
      background-color:#D5EFFE;
    }
    & button {
      width: 24px;
      height: 24px;
      background-color:transparent;
      border: none;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18 6L6 18' stroke='%233C5AC3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M6 6L18 18' stroke='%233C5AC3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }
    & button:hover,
    & button:active {
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18 6L6 18' stroke='rgb(35,71,198)' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M6 6L18 18' stroke='rgb(35,71,198)' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }
  }
  .cost-modal__no-data {
    text-align: center;
    padding: 1rem;
    color: black;
    font-size: 16px;
  }

</style>
